import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import messages from '../messages';
import errorManage from '../errorManage';
import auroraDivisionServices from './auroraDivision.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getAuroraDivision = (params) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_AURORA_DIVISION,
      payload: true
    });
   
    const resp = await auroraDivisionServices.getAuroraDivisions(params);
    dispatch({
      type: actions.GET_AURORA_DIVISION,
      payload: {
        auroraDivision: resp.data.data,
        auroraDivisionLength: resp.data.count
      }
    });
    dispatch({
      type: actions.AURORA_DIVISION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.AURORA_DIVISION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_AURORA_DIVISION,
      payload: false
    });
  }
}

export const saveAuroraDivision = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_AURORA_DIVISION,
      payload: true
    });

    const resp = await auroraDivisionServices.saveAuroraDivision(req);
    const { auroraDivision, auroraDivisionLength } = getState().auroraDivision;
    const _auroraDivision = [...auroraDivision, resp.data];
    dispatch({
      type: actions.GET_AURORA_DIVISION,
      payload: {
        auroraDivision: _auroraDivision,
        auroraDivisionLength: auroraDivisionLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_AURORA_DIVISION,
      payload: false
    });
  }
}

export const editAuroraDivision = (req, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_AURORA_DIVISION,
      payload: true
    });

    const resp = await auroraDivisionServices.editAuroraDivision(id, req);
    const { auroraDivision, auroraDivisionLength } = getState().auroraDivision;
    auroraDivision[index] = resp.data;
    dispatch({
      type: actions.GET_AURORA_DIVISION,
      payload: {
        auroraDivision: auroraDivision,
        auroraDivisionLength: auroraDivisionLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.LOADING_AURORA_DIVISION,
      payload: false
    });
  }
}

export const deleteAuroraDivision = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_AURORA_DIVISION,
      payload: true
    });

    await auroraDivisionServices.deleteAuroraDivision(id);
    const { auroraDivision, auroraDivisionLength } = getState().auroraDivision
    auroraDivision.splice(index, 1);
    dispatch({
      type: actions.GET_AURORA_DIVISION,
      payload: {
        auroraDivision: auroraDivision,
        auroraDivisionLength: auroraDivisionLength-1
      }
    });
    dispatch({
      type: actions.AURORA_DIVISION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.AURORA_DIVISION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_AURORA_DIVISION,
      payload: false
    });
  }
}